import { api } from '../utils/libs/axios'
import { NewFeedbackSchema } from '../utils/types/feedback'

const create = async (payload: NewFeedbackSchema) => api.post(`/v1/feedback`, payload)

export const FeedbackService = { create }
